import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ModalResponseDetails from "components/Common/ModalResponseDetails";
import {
  handleUpdateNewResponse,
  addButtonLabelLanguage,
  deleteButtonLabelLanguage,
  handleAddTag,
  handleRemoveTag
} from "./actions";

class NewResponseModal extends React.PureComponent {
  /**
   * @returns {ReactElement}
   */
  render() {
    const { onSave } = this.props;

    return (
      <ModalResponseDetails
        {...this.props}
        onSave={onSave}
        handleUpdateResponse={this.props.handleUpdateNewResponse}
        addButtonLabelLanguage={this.props.addButtonLabelLanguage}
        deleteButtonLabelLanguage={this.props.deleteButtonLabelLanguage}
        handleAddTag={this.props.handleAddTag}
        handleRemoveTag={this.props.handleRemoveTag}
      />
    );
  }
}

NewResponseModal.propTypes = {
  onSave: PropTypes.func
};

NewResponseModal.defaultProps = {
  onSave: null
};

/**
 * @param {Object} state
 * @returns {Object}
 */
function mapState(state) {
  const { newResponseModal } = state;

  return {
    response: newResponseModal.get("response")
  };
}

function mapDispatch(dispatch) {
  return {
    handleUpdateNewResponse: bindActionCreators(handleUpdateNewResponse, dispatch),
    addButtonLabelLanguage: bindActionCreators(addButtonLabelLanguage, dispatch),
    deleteButtonLabelLanguage: bindActionCreators(deleteButtonLabelLanguage, dispatch),
    handleAddTag: bindActionCreators(handleAddTag, dispatch),
    handleRemoveTag: bindActionCreators(handleRemoveTag, dispatch)
  };
}

const Connector = connect(mapState, mapDispatch)(NewResponseModal);

export default Connector;
